var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MultiLvSelectArea",
    _vm._g(
      _vm._b(
        { ref: "MultiLvSelectArea", attrs: { data: _vm.sortSelectArea } },
        "MultiLvSelectArea",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }